// extracted by mini-css-extract-plugin
export var sbShowMain = "iframeEmbed-module--sb-show-main--YpNCL";
export var iframeWrapper = "iframeEmbed-module--iframeWrapper--2hhJh";
export var iframe = "iframeEmbed-module--iframe--1DlRI";